import {IElement} from '../../incase-domain/elements';
import generateImageTemplate from './generators/image';
import generateTitleSubtitleTemplate from './generators/titleSubtitle';
import generateTitleTextImageTemplate from './generators/titleTextImage';
import {TEMPLATE} from './types';

function createSlideTemplate(type: TEMPLATE, slideId: string): IElement[] {
    switch (type) {
        case TEMPLATE.IMAGE:
            return generateImageTemplate(slideId);
        case TEMPLATE.TITLE_SUBTITLE:
            return generateTitleSubtitleTemplate(slideId);
        case TEMPLATE.TITLE_TEXT_IMAGE:
            return generateTitleTextImageTemplate(slideId);
        default:
            return [];
    }

    return [];
}

export default createSlideTemplate;
